import { createUseStyles } from 'react-jss';

const line = {
  content: '""',
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '2px',
};

export const withColor = {
  'body[theme="dark"] &': {
    color: 'var(--section-dark-color)',
  },

  'body[theme="light"] &': {
    color: 'var(--section-light-color)',
  },
};
const withBgColor = {
  'body[theme="dark"] &': {
    backgroundColor: 'var(--section-dark-color)',
  },

  'body[theme="light"] &': {
    backgroundColor: 'var(--section-light-color)',
  },
};

const useStyles = createUseStyles(() => ({
  colorfulSectionWrapper: {
    '&:has(.headline.withImage) .sectionImage': {
      '&:before': {
        ...line,
        ...withBgColor,
      },
    },

    '&:has(.headline)': {
      '& .sectionTop': {
        '& .textPreview , & .viboInput, & .viboTextarea': {
          '&:not(:active)': {
            ...withColor,
          },
        },
      },
    },

    '& .section, &.section': {
      '&:not(.selected):not(.headline)': {
        overflow: 'hidden',

        '&:before': {
          ...line,
        },
      },

      '&:not(.selected):not(.headline):not(.dontPlay)': {
        '&:before': {
          ...withBgColor,
        },
      },

      '&.dontPlay:not(.selected):before': {
        backgroundColor: 'var(--clr-carnation)',
      },
    },
  },
}));

export default useStyles;
